import React from 'react';
import { Field } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy';
import MetricListContainer from 'src/components/BeaconV2Components/MetricList/MetricListContainer';
import ProductListContainer from 'src/components/BeaconV2Components/MetricList/ProductListContainer';
import { getWeekColumnDefinition } from 'src/components/BeaconV2Components/MetricList/headColumnDefinitions';
import { removeComparisonFormatter } from 'src/components/BeaconV2Components/MetricList/utils';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import { CHARGEBACK_FIELDS } from 'src/utils/entityDefinitions/fields/operationsFieldDefinitions';
import { BEACON_INDEX_NAMES } from 'src/utils/entityDefinitions/indexes/beaconIndexNames';

const fields: Field[] = [
  { name: 'financialCharge' },
  { name: 'chargebackRate' },
  { name: 'prepCharges' },
  { name: 'logisticCharges' },
  { name: 'labelingCharges' },
  { name: 'onTimeCharges' },
  { name: 'otherCharges' },
  { name: 'quantity' }
];

const ChargebackProductsList = () => {
  const { isProductEntity } = useProductEntity();

  const weekEndingFields = fields.map(removeComparisonFormatter);

  return isProductEntity ? (
    <MetricListContainer
      entityTableHeaderProps={{
        title: 'Financial Charge by Week'
      }}
      indexName={BEACON_INDEX_NAMES.CHARGEBACKS}
      sortFieldName={CHARGEBACK_FIELDS.financialCharge.name}
      fields={weekEndingFields}
      headColumnDefinition={getWeekColumnDefinition({
        getTableColumnProps(defaults) {
          return {
            ...defaults,
            style: {
              ...defaults.style,
              width: '220px'
            }
          };
        }
      })}
      postProcessData={(data) => {
        return data.sort((a, b) => b.weekId.localeCompare(a.weekId));
      }}
      useTableDataProps={{
        groupByFieldName: 'weekId',
        filterResponse: () => true,
        itemsPerPage: 100
      }}
      showGrid={false}
    />
  ) : (
    <ProductListContainer
      entityTableHeaderProps={{
        title: 'Products - Financial Charge'
      }}
      indexName={BEACON_INDEX_NAMES.CHARGEBACKS}
      sortFieldName={CHARGEBACK_FIELDS.financialCharge.name}
      fields={fields}
    />
  );
};

export default ChargebackProductsList;
